import { PAGE_TYPE } from "@/libs/analytics/types";
import {
  getCountdownsFromDateTimes,
  isCountdownActive,
} from "@/src/helpers/countdowns";
import { getCollectionRevealDates } from "@/src/helpers/getCollectionRevealDates";
import { MapFavoriteErrorToast } from "@/src/routes/collections/routes/[collectionName]/routes/products/routes/[productName]/routes/tokens/routes/[tokenId]/components/TokenListingInformationModule/TokenListingFavoriteErrorToast";
import { FavoriteError } from "@/src/routes/collections/routes/[collectionName]/routes/products/routes/[productName]/types";
import { Collection } from "nvs-types/dist/types/generated/contentful";

export const convertISODateStringToMonthAndYear = (d?: string) => {
  if (d === undefined) return undefined;
  const date = new Date(d);
  const month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
    date,
  );
  const year = date.getFullYear();
  return `${month} ${year}`;
};

export const copyTextToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
};

const createShareURLForTest = (swooshHandle: string) => {
  return `https://${swooshHandle}.swoosh-dev.nike`;
};

const createShareURLForProd = (swooshHandle: string) => {
  return `https://${swooshHandle}.swoosh.nike`;
};

export const createShareURL = (swooshHandle: string) => {
  return process.env.NEXT_PUBLIC_CURRENT_ENV !== "production"
    ? createShareURLForTest(swooshHandle)
    : createShareURLForProd(swooshHandle);
};

export const getProductName = (
  collectionSlug: string,
  productSlug: string,
  swooshHandle: string,
) => {
  // Product slugs for `base` products such as `base-swoosh-id` need user specific data to create TLP slugs
  return collectionSlug === "swoosh-id"
    ? swooshHandle
    : (productSlug as string);
};

export const isCollectionRevealable = (collectionData: Collection) => {
  const hasRevealCollection = collectionData?.revealCollection;

  const collectionRevealTimes =
    collectionData && getCollectionRevealDates(collectionData);

  const revealCountDowns =
    collectionRevealTimes &&
    getCountdownsFromDateTimes(collectionRevealTimes, "Reveal");

  const activeCountdown = isCountdownActive(revealCountDowns);

  // Collection has reveal date but the date has passed
  return hasRevealCollection && revealCountDowns && !activeCountdown;
};

// NOTE: this is not scalable -- We need to include this data in the nft/metadata
const SWOOSH_ID_COLLECTION_SLUG = "swoosh-id";
export const isCollectionSolebound = (collectionSlug: string) =>
  collectionSlug === SWOOSH_ID_COLLECTION_SLUG;

export const getFavoritesErrorToastComponent = (
  signedIn: boolean,
  pageType: PAGE_TYPE,
) =>
  signedIn
    ? MapFavoriteErrorToast(pageType)[FavoriteError.SIGN_IN]
    : MapFavoriteErrorToast(pageType)[FavoriteError.ERROR];
